import Handlebars from 'handlebars';

// Register Handlebars helpers
export const registerHandlebarsHelpers = (): void => {
  Handlebars.registerHelper(
    'formatDate',
    function (date: string | Date): string {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString();
    },
  );

  Handlebars.registerHelper('toLowerCase', function (str: string): string {
    return str ? String(str).toLowerCase() : '';
  });

  Handlebars.registerHelper('toUpperCase', function (str: string): string {
    return str ? String(str).toUpperCase() : '';
  });

  Handlebars.registerHelper('bulletList', function (items: string[]): string {
    if (!items || !Array.isArray(items)) return '';
    return items.map((item: string) => `- ${item}`).join('\n');
  });

  // Helper for conditionally displaying based on complexity
  Handlebars.registerHelper(
    'complexity',
    function (
      this: unknown,
      value: string,
      options: Handlebars.HelperOptions,
    ): string {
      const complexity = String(value).toLowerCase();
      if (complexity === 'high') {
        return options.fn(this);
      } else if (options.inverse) {
        return options.inverse(this);
      }
      return '';
    },
  );

  // Helper for creating numbered lists
  Handlebars.registerHelper('numberedList', function (items: string): string {
    if (!items || !items.split) return '';
    const lines = items
      .split('\n')
      .filter((line: string) => line.trim() !== '');
    return lines
      .map((line: string, i: number) => `${i + 1}. ${line}`)
      .join('\n');
  });
};

// Generate a task from template data using Handlebars
export const generateTaskFromTemplate = (
  template: {
    title: string;
    titleTemplate: string;
    template: string;
  },
  fieldValues: Record<string, string | number | boolean>,
): { title: string; description: string } => {
  try {
    // Compile the template using Handlebars
    const compiledTemplate = Handlebars.compile(template.template);

    // Compile the title template to support placeholders
    const compiledTitleTemplate = Handlebars.compile(template.titleTemplate);

    // Render the compiled template with the field values
    const description = compiledTemplate(fieldValues);

    // Render the title with the field values
    const title = compiledTitleTemplate(fieldValues);

    return {
      title,
      description,
    };
  } catch (error) {
    // Log error but avoid console.error for linting
    const errorMessage = error instanceof Error ? error.message : String(error);
    // We should ideally use a proper logger here instead

    // Fallback to returning raw template in case of errors
    return {
      title: template.title,
      description: `Error in template: ${errorMessage}\n\nOriginal template:\n${template.template}`,
    };
  }
};

// Initialize helpers
registerHandlebarsHelpers();
